module.exports = __webpack_public_path__ + "static/img/illustratepic_02.c3d5446.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/en/illustratepic_02.png
// module id = x2kc
// module chunks = 1